import mapboxgl from "mapbox-gl";
import { addSourcesIfNotExist } from "../../map/sources";

export const neighborsSources = {
    neighborsGoNGSrc: "neighbor_goNG",
    neighborsGoOKSrc: "neighbor_goOK",
    neighborsCruiseNGSrc: "neighbor_cruiseNG",
    neighborsCruiseOKSrc: "neighbor_cruiseOK",
};

export const initSources = (map: mapboxgl.Map): void => {
    addSourcesIfNotExist(map, Object.values(neighborsSources));
};
